import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';
import { keyframes } from '@angular/core/src/animation/dsl';

@Directive({
    selector: '[snFiledrop]'
})
export class FiledropDirective {
    @HostBinding('class.fileover') fileOver: boolean;
    @Output() fileDropped = new EventEmitter<any>();

    constructor() { }

    @HostListener('dragover', ['$event']) onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = true;
        console.log('Drag Over');
    }

    @HostListener('dragleave', ['$event']) onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        console.log('Drag Leave');
    }

    @HostListener('drop', ['$event']) public onDrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.fileOver = false;
        const files = evt.dataTransfer.files;
        if (files.length > 0) {
            this.fileDropped.emit(files);
            console.log('You dropped ${files.length} files.');
        }
    }

}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/directives/filedrop.directive.ts